interface IProps {
    message: string
}

const HeaderMessage = ({message}: IProps) => {
    return (
        <h3 className="mb-[10px] mt-[10px] text-[18px] font-bold uppercase tracking-header [letter-spacing:1px] sm:text-[18px]">
            {message}
        </h3>
    )
}

export default HeaderMessage
